import React from "react";
import { EntityGrid } from "../../components/grid/EntityGrid";
import { ActivityLogTransports } from "../../transports/activityLog";
import useActivityGridColumns from "./useActivityGridColumns";

export const ActivityGrid: React.FC = () => {
    const gridColumns = useActivityGridColumns();

    return (
        <EntityGrid
            rowModelType="serverSide"
            listHandler={ActivityLogTransports.listAll}
            totalFilteredHandle={ActivityLogTransports.totalFiltered}
            totalRowsHandle={ActivityLogTransports.totalRows}
            columns={gridColumns}
        />
    );
};
